var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestaurantActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4697 18.5V19.5C22.4697 21.15 22.4697 22.5 19.4697 22.5H5.46973C2.46973 22.5 2.46973 21.15 2.46973 19.5V18.5C2.46973 17.95 2.91973 17.5 3.46973 17.5H21.4697C22.0197 17.5 22.4697 17.95 22.4697 18.5Z",
    fill: "url(#paint0_linear_6266_2327)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9095 5.67977C14.9595 5.47977 14.9895 5.28977 14.9995 5.07977C15.0295 3.91977 14.3195 2.89977 13.1995 2.59977C11.5195 2.13977 9.99953 3.39977 9.99953 4.99977C9.99953 5.23977 10.0295 5.45977 10.0895 5.67977C6.47953 6.44977 3.76953 9.65977 3.76953 13.4998V14.9998C3.76953 15.5498 4.21953 15.9998 4.76953 15.9998H20.2195C20.7695 15.9998 21.2195 15.5498 21.2195 14.9998V13.4998C21.2195 9.65977 18.5195 6.45977 14.9095 5.67977ZM15.4995 12.2498H9.49953C9.08953 12.2498 8.74953 11.9098 8.74953 11.4998C8.74953 11.0898 9.08953 10.7498 9.49953 10.7498H15.4995C15.9095 10.7498 16.2495 11.0898 16.2495 11.4998C16.2495 11.9098 15.9095 12.2498 15.4995 12.2498Z",
    fill: "url(#paint1_linear_6266_2327)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6266_2327",
    x1: 12.4697,
    y1: 17.5,
    x2: 12.4697,
    y2: 22.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6266_2327",
    x1: 12.4945,
    y1: 2.50391,
    x2: 12.4945,
    y2: 15.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurantActive);
export default __webpack_public_path__ + "static/media/restaurant-active.aaa6b9fc56b3e273e72247ee828b2a62.svg";
export { ForwardRef as ReactComponent };